// extracted by mini-css-extract-plugin
module.exports = {"copyText":"CopyInput_copyText_3EVrj","copyButton":"CopyInput_copyButton_2dW9I","subtitle":"CopyInput_subtitle_1OsjU"};